var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@emotion/styled';
import { position, display, flexDirection, width, height, boxShadow, themeGet, justifyContent, } from 'styled-system';
import { getPageAppTrackerProps, } from '../../common/tracking/getTrackerProps';
import { InformationBox, } from './InformationBox';
import { SlideBackground, } from './SlideBackground';
var SlideContainer = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", ";\n  ", ";\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  text-decoration: none;\n  background-color: ", ";\n"], ["\n  ", "\n  ", ";\n  ", ";\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  text-decoration: none;\n  background-color: ", ";\n"])), position, display, flexDirection, justifyContent, height, boxShadow, width, function (_a) {
    var bg = _a.bg;
    return bg || themeGet('colors.gray.12');
});
SlideContainer.defaultProps = {
    position: 'relative',
    display: 'flex',
    flexDirection: ['column', 'row'],
    justifyContent: 'flex-end',
    height: [368, 220, 304, 394],
    width: 1,
};
export var HomepageTopTeaserSlide = function (_a) {
    var index = _a.index, _b = _a.item, stoerer = _b.stoerer, imageProps = _b.image, campaignDuration = _b.campaignDuration, countDown = _b.countDown, title = _b.title, subtitle = _b.subtitle, cta = _b.cta, fullWidthImage = _b.fullWidthImage, informationBoxBg = _b.informationBoxBg, informationBoxColor = _b.informationBoxColor, legalDisclaimer = _b.legalDisclaimer, _c = _b.tracking, _d = _c === void 0 ? {} : _c, name = _d.name, placement = _d.placement;
    return (React.createElement(SlideContainer, __assign({}, getPageAppTrackerProps(__assign(__assign({}, (index === 0 && {
        'data-prefetch': true,
    })), { 'data-testid': "homepage-top-teaser-slide-" + index, type: cta.type, href: cta.href, bg: informationBoxBg }), {
        event: 'promoClick',
        eventData: {
            promotions: [
                {
                    name: name,
                    placement: placement,
                    position: index,
                },
            ],
        },
    })),
        React.createElement(InformationBox, { title: title, subtitle: subtitle, campaignDuration: campaignDuration, countDown: countDown, cta: cta, fullWidthImage: fullWidthImage, informationBoxBg: informationBoxBg, informationBoxColor: informationBoxColor }),
        React.createElement(SlideBackground, { stoerer: stoerer, image: imageProps, legalDisclaimer: legalDisclaimer, fullWidthImage: fullWidthImage })));
};
var templateObject_1;
